import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Breadcrumbs from "@/components/Breadcrumbs";
import BottomNav from "@/components/BottomNav";
import ProtocolShell from "@/components/protocol/ProtocolShell";
import ShellRouteBridge from "@/components/protocol/ShellRouteBridge";
import ProtocolResumeWidget from "@/components/protocol/ProtocolResumeWidget";
import LineupRealtimeBridge from "@/components/realtime/LineupRealtimeBridge";
import NativeOnboardingHighlights from "@/components/native/NativeOnboardingHighlights";
import { ProtocolShellProvider } from "@/contexts/ProtocolShellContext";

export default function RootLayout() {
  const { pathname } = useLocation();
  const compactTopSpacing = pathname.startsWith("/account/matches/saved/");

  return (
    <ProtocolShellProvider>
      <NativeOnboardingHighlights />
      <div className="lapstr-app-shell min-h-screen bg-background text-foreground from-slate-50 to-slate-100">
        <Header />

        <main
          className={`lapstr-app-main native-bottom-nav-clearance mx-auto max-w-7xl px-4 pb-24 ${compactTopSpacing ? "pt-2" : "pt-8"} sm:px-6 sm:pb-8 lg:px-8`}
          data-compact-top={compactTopSpacing ? "true" : "false"}
        >
          <ShellRouteBridge />
          <div className="hidden sm:block">
            <Breadcrumbs />
          </div>
          <Outlet />
        </main>

        <BottomNav />
        <LineupRealtimeBridge />
        <ProtocolResumeWidget />
        <ProtocolShell />
      </div>
    </ProtocolShellProvider>
  );
}
